import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-reservations-report-header',
  templateUrl: './reservations-report-header.component.html',
  styleUrls: ['./reservations-report-header.component.css']
})
export class ReservationsReportHeaderComponent {
  @Input() title = 'Reporte de Reservas';
  @Input() subtitle =
    'Consulta reservas de OS disponibles, filtra por estado/proveedor y abre el PDF.';
  @Input() resultCount = 0;
  @Input() loadedCount = 0;
  @Input() activeFilterCount = 0;
  @Input() isLoading = false;
  @Input() isLoadingMore = false;

  @Output() refresh = new EventEmitter<void>();
}
